const HUBPAGE_TEST_IDS = {
  HUBPAGE_TITLE: 'hubpage-title',
  HUBPAGE_DESCRIPTION: 'hubpage-description',
  HUBPAGE_ARTICLE_GRID: 'hubpage-article-grid',
  HUBPAGE_ARTICLE_CARD: 'hubpage-article-card',
  HUBPAGE_CATEGORY_TITLE: 'hubpage-category-title',
  HUBPAGE_CATEGORY_MORE: 'hubpage-category-more',
  SUBSECTION_NAV: 'subsection-nav',
  SHOW_MORE_BTN: 'show-more-btn',
  SECTION_TITLE_MORE: 'section-title-more',
};
export default HUBPAGE_TEST_IDS;
